import {
  GET_EMPLOYEES,
  GET_EMPLOYEES_SUCCESS,
  GET_PARTS,
  GET_PARTS_SUCCESS,
  API_ERROR,
  GET_COMPANIES,
  GET_COMPANIES_SUCCESS,
  GET_GRADES,
  GET_GRADES_SUCCESS,
  GET_GROUPS,
  GET_GROUPS_SUCCESS,
  FULL_SIZE_LOADING,
  GET_CARE_COMPANIES,
  GET_CARE_COMPANIES_SUCCESS,
  GET_UNREAD_NOTIFICATION_COUNT,
  GET_UNREAD_NOTIFICATION_COUNT_SUCCESS,
  GET_TAXPAYER_LIST,
  GET_TAXPAYER_LIST_SUCCESS,
} from "./actionTypes";

export const getStoreEmployees = (employee) => ({
  type: GET_EMPLOYEES,
  payload: employee,
});

export const getStoreEmployeesSuccess = (employees) => {
  return {
    type: GET_EMPLOYEES_SUCCESS,
    payload: employees,
  };
};

export const getStoreParts = (params) => ({
  type: GET_PARTS,
  payload: params,
});

export const getStorePartsSuccess = (parts) => {
  return {
    type: GET_PARTS_SUCCESS,
    payload: parts,
  };
};
export const getStoreCompanies = (params) => ({
  type: GET_COMPANIES,
  payload: params,
});

export const getStoreCompaniesSuccess = (companies) => {
  return {
    type: GET_COMPANIES_SUCCESS,
    payload: companies,
  };
};
export const getStoreCareCompanies = (params) => ({
  type: GET_CARE_COMPANIES,
  payload: params,
});

export const getStoreCareCompaniesSuccess = (companies) => {
  return {
    type: GET_CARE_COMPANIES_SUCCESS,
    payload: companies,
  };
};

export const getStoreGrades = (params) => ({
  type: GET_GRADES,
  payload: params,
});

export const getStoreGradesSuccess = (grades) => {
  return {
    type: GET_GRADES_SUCCESS,
    payload: grades,
  };
};

export const getStoreGroups = (params) => ({
  type: GET_GROUPS,
  payload: params,
});

export const getStoreGroupsSuccess = (groups) => {
  return {
    type: GET_GROUPS_SUCCESS,
    payload: groups,
  };
};

export const getUnreadNotificationCount = (params) => ({
  type: GET_UNREAD_NOTIFICATION_COUNT,
  payload: params,
});

export const getUnreadNotificationCountSuccess = (groups) => {
  return {
    type: GET_UNREAD_NOTIFICATION_COUNT_SUCCESS,
    payload: groups,
  };
};

export const fullSizeLoading = (isLoading) => {
  return {
    type: FULL_SIZE_LOADING,
    payload: isLoading,
  };
};

export const apiError = (error) => ({
  type: API_ERROR,
  payload: error,
});

export const getTaxpayerList = (params) => ({
  type: GET_TAXPAYER_LIST,
  payload: params
});
export const getTaxpayerListSuccess = (taxpayerList) => ({
  type: GET_TAXPAYER_LIST_SUCCESS,
  payload: taxpayerList
});